import { createContext, useContext, useSyncExternalStore } from "react";
import type { AccountSettingsValue } from "./account-settings";
import type { AccountSettingsStore } from "./account-settings-store";

/**
 * Контекст настроек аккаунта. Модуль — лист графа: он знает хранилище только по
 * типу, чтобы хуки `useDensityFilters`, `useCardRowOrder` и `useSidebarOpen`
 * могли жить в прежних файлах рядом с прежними читателями браузера, которые
 * нужны переезду (`account-settings.ts`).
 */
export const AccountSettingsContext = createContext<AccountSettingsStore | null>(null);

export function useAccountSettingsStore(): AccountSettingsStore {
  const store = useContext(AccountSettingsContext);
  if (store === null) {
    throw new Error("настройки аккаунта: нет AccountSettingsProvider над экраном");
  }
  return store;
}

/** Одно из трёх значений настроек; перерисовка — только когда меняется оно само. */
export function useAccountSetting<K extends keyof AccountSettingsValue>(
  key: K,
): [AccountSettingsStore, AccountSettingsValue[K]] {
  const store = useAccountSettingsStore();
  const read = () => store.getState().value[key];
  const value = useSyncExternalStore(store.subscribe, read, read);
  return [store, value];
}
